<template>
  <div class="popup-box flex flex-column" style="position: relative">
    <ul class="form-box">
      <el-form :model="state.model" ref="formDom" class="infoForm">
        <el-form-item
          label="名称"
          prop="name"
          :rules="[{ required: true, message: '请填写名称', trigger: 'blur' }]"
        >
          <el-input v-model="state.model.name"></el-input>
        </el-form-item>
        <el-form-item
          label="所属客户"
          prop="name"
          :rules="[
            { required: true, message: '请选择所属客户', trigger: 'blur' },
          ]"
        >
          <el-select v-model="state.model.customer_id" :disabled="props.id">
            <el-option
              v-for="item in state.customerData"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            />
            <template #footer>
              <el-button size="small" @click="onLoadCustomer()">
                刷新
              </el-button>
            </template>
          </el-select>
        </el-form-item>
        <el-form-item
          label="薪资所属期"
          prop="month"
          :rules="[
            { required: true, message: '请选择薪资所属期', trigger: 'blur' },
          ]"
        >
          <el-date-picker
            v-model="state.model.month"
            type="month"
            format="YYYY年M月"
            value-format="YYYY-MM"
            :disabled="props.id"
          />
        </el-form-item>
        <el-form-item
          label="税款所属期"
          prop="tax_month"
          :rules="[
            { required: true, message: '请选择税款所属期', trigger: 'blur' },
          ]"
        >
          <el-date-picker
            v-model="state.model.tax_month"
            type="month"
            format="YYYY年M月"
            value-format="YYYY-MM"
            :disabled="props.id"
          />
        </el-form-item>
        <el-form-item
          label="报税类型"
          prop="d_tax_type_id"
          :rules="[
            { required: true, message: '请选择报税类型', trigger: 'blur' },
          ]"
        >
          <el-select v-model="state.model.d_tax_type_id" :disabled="props.id">
            <el-option
              v-for="item in state.taxTypeData"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            />
            <template #footer>
              <el-button size="small" @click="onLoadTaxType()">
                刷新
              </el-button>
            </template>
          </el-select>
        </el-form-item>
        <el-form-item label="约定发薪日期">
          <el-date-picker
            v-model="state.model.pay_date"
            type="date"
            value-format="YYYY-MM-DD"
          />
        </el-form-item>
        <el-form-item
          label="客服专员"
          prop="belonger_id"
          :rules="[
            { required: true, message: '请选择客服专员', trigger: 'blur' },
          ]"
        >
          <el-tree-select
            v-model="state.model.belonger_id"
            :props="{
              value: 'id',
              label: 'name',
              class: 'belonger-tree-class',
            }"
            placeholder="负责人"
            :data="state.admin_data"
            style="width: 200px"
            default-expand-all
            node-key="id"
            value-key="id"
            filterable
            clearable
            @current-change="onBelongerChange"
          >
            <template #default="{ data }">
              <el-icon :size="16" v-if="data.type == 0"><UserFilled /></el-icon>
              <el-icon :size="16" v-else><User /></el-icon>
              <span style="margin-left: 3px">{{ data.name }}</span>
            </template>
          </el-tree-select>
        </el-form-item>
        <el-form-item
          label="个税承担方式"
          prop="tax_mode"
          :rules="[
            { required: true, message: '请选择个税承担方式', trigger: 'blur' },
          ]"
        >
          <el-radio-group v-model="state.model.tax_mode">
            <el-radio-button :label="0">个人</el-radio-button>
            <el-radio-button :label="1">公司</el-radio-button>
          </el-radio-group>
        </el-form-item>
        <template v-if="props.id">
          <el-form-item label="创建时间">
            <el-input v-model="state.model.create_time" disabled></el-input>
          </el-form-item>
          <el-form-item label="修改时间">
            <el-input v-model="state.model.update_time" disabled></el-input>
          </el-form-item>
        </template>
      </el-form>
    </ul>
    <ul class="submit-box">
      <el-button type="primary" @click="onSubmit">提交</el-button>
    </ul>
  </div>
</template>

<script>
import { onMounted, reactive, ref } from "vue";
import { payroll_add, payroll_edit, payroll_detail } from "@/http/payroll";
import { admin_cascader } from "@/utils/qFormat";
import { data_customer_select } from "@/http/data";
import { taxtype_select } from "@/http/dictionary";
import { post_response } from "@/utils/qFormat";
import { ElMessage } from "element-plus";

export default {
  props: {
    id: Number,
  },
  setup(props, { emit }) {
    const formDom = ref(null);
    const state = reactive({
      model: {},
    });
    onMounted(() => {
      onLoadCustomer();
      onLoadAdmin();
      onLoadTaxType();

      if (props.id) {
        payroll_detail(props.id).then((res) => {
          if (res.status == 200) {
            state.model = res.data.data;
            if (state.model.pid == 0) delete state.model.pid;
          }
        });
      }
    });

    //获取客户
    const onLoadCustomer = () => {
      data_customer_select().then((res) => {
        if (res.status == 200) state.customerData = res.data.data?.list;
      });
    };

    //获取业务员
    const onLoadAdmin = () => {
      admin_cascader().then((res) => {
        state.admin_data = res;
      });
    };

    //业务员改变事件需要获取其部门id
    const onBelongerChange = (item) => {
      state.model.belonger_department_id = item.pid;
    };

    const onLoadTaxType = () => {
      taxtype_select().then((res) => {
        if (res.status == 200) state.taxTypeData = res.data.data;
      });
    };

    const onSubmit = () => {
      formDom.value.validate((valid) => {
        if (valid) {
          if (props.id) {
            payroll_edit(state.model).then((res) => {
              post_response(res, emit);
            });
          } else {
            payroll_add(state.model).then((res) => {
              if (res.status == 200) {
                const { msg, data } = res.data;
                ElMessage.success(msg);
                emit("close", data.id);
              }
            });
          }
        }
      });
    };
    return {
      state,
      props,
      formDom,
      onSubmit,
      onLoadCustomer,
      onLoadAdmin,
      onLoadTaxType,
      onBelongerChange,
    };
  },
};
</script>
<style scoped lang="less"></style>
